import { auth, logout } from "../../firebase/firebase";
import "../NoAccess/NoAccess.css"
const PermissionDenied = () => {

    const Logmeout = () => {
      sessionStorage.clear()
      localStorage.clear()
      logout(auth);
    };

  return (
    <div className={`no-access-container`}>
      <div style={{ float: "right" }} className="row">
        <button onClick={(e) => Logmeout(e)} className="btn btn-sm btn-primary">
          <i className="fa fa-times"></i>
        </button>
      </div>
      <div style={{ marginTop: "5%" }}>
        <div className={`s-nm`}>
        It looks like your account isn’t linked to any team yet. Kindly contact your company administrator to complete your access setup.
        Or else you can email <strong>(associate@logisticsnow.in)</strong> or call <strong>+91-9653620207</strong>.
        </div>
      </div>
      <div style={{ marginTop: "3%" }} className="row">
        <button
          style={{ marginLeft: "50%" }}
          onClick={(e) => Logmeout(e)}
          className="btn btn-sm btn-primary s-try"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default PermissionDenied;
